"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var core_1 = require("@material-ui/core");
var theme_1 = require("../../app/style/theme");
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a;
    return ({
        root: (_a = {
                margin: '0 auto',
                padding: theme.spacing(0, 12),
                overflowY: 'scroll',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
                maxWidth: 1080,
                '&::-webkit-scrollbar': {
                    width: 0,
                    background: 'transparent', // Make scrollbar invisible
                }
            },
            _a[theme.breakpoints.down('xs')] = {
                padding: theme.spacing(0, 2),
            },
            _a),
        wide: {
            maxWidth: 1368,
        },
        modalContainer: {
            minHeight: "calc(100vh - ".concat(theme_1.headerHeight, "px)"),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            '&:focus': {
                outline: 'none',
            },
        },
    });
}, { name: 'OverlayModal' });
var OverlayModal = function (_a) {
    var _b;
    var open = _a.open, onClose = _a.onClose, children = _a.children, wide = _a.wide;
    var classes = useStyles();
    var theme = (0, core_1.useTheme)();
    return (React.createElement(core_1.Modal, { open: open, onClose: onClose, BackdropProps: { style: { backgroundColor: theme.palette.background.default, opacity: 0.95, top: theme_1.headerHeight } }, style: { top: theme_1.headerHeight }, className: (0, classnames_1.default)(classes.root, (_b = {}, _b[classes.wide] = wide, _b)) },
        React.createElement("div", { className: (0, classnames_1.default)(classes.modalContainer) }, open && children)));
};
OverlayModal.defaultProps = {
    wide: false,
    onClose: null,
};
exports.default = OverlayModal;
